module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hr":{"title":"403","subtitle":"Zabranjen pristup","message":"Nemate pravo pristupa ovoj stranici. Kliknite na gumb za povratak na početnu stranicu."},"en":{"title":"403","subtitle":"Access denied","message":"You cannot access this page. Please return to the home page."}}')
  delete Component.options._Ctor
}
